import * as Sentry from '@sentry/vue'
import type { App } from 'vue'
import type { Router } from 'vue-router'

export const initializeSentry = (app: App, router: Router) => {
  Sentry.init({
    environment: import.meta.env.VITE_ENVIRONMENT,
    app,
    dsn: 'https://d3ff6aa04611dfcdda41123951a813b2@o4506652311224320.ingest.sentry.io/4506652313714688',
    integrations: [
      new Sentry.BrowserTracing({
        routingInstrumentation: Sentry.vueRouterInstrumentation(router)
      }),
      Sentry.replayIntegration()
    ],

    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: 1.0,

    // Set `tracePropagationTargets` to control for which URLs distributed tracing should be enabled
    tracePropagationTargets: [/^.+\.trial\.co-assign\.com$/, /^.+\.co-assign\.com$/],

    // Capture Replay for 10% of all sessions,
    // plus for 100% of sessions with an error
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0
  })
}
